import type * as BrowserAgentModule from '@newrelic/browser-agent/loaders/browser-agent'

const initNewRelic = () => {
  if (process.env.NODE_ENV !== 'production') return undefined

  // The package reads browser globals when loaded. Require it synchronously
  // inside the production guard so dev/tests avoid those side effects.
  const { BrowserAgent } =
    require('@newrelic/browser-agent/loaders/browser-agent') as typeof BrowserAgentModule

  return new BrowserAgent({
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: 'NRJS-4a4ea09d02b7277a855',
      applicationID: '1589021201',
      sa: 1,
    },
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true,
      },
      ajax: { deny_list: ['bam.nr-data.net'] },
    },
    loader_config: {
      accountID: '2692182',
      trustKey: '2692182',
      agentID: '1589021201',
      licenseKey: 'NRJS-4a4ea09d02b7277a855',
      applicationID: '1589021201',
    },
  })
}

// Keep this module as the first static import of each app entry point.
export const newRelicAgent = initNewRelic()
